import React from "react";
import { supportLinkType } from "../../common/types/search/search";
import { KNOWLEDGE_BASE_LINK } from "../constants";

export function SupportLink({
	supportLink,
}: {
	supportLink?: supportLinkType;
}) {
	if (!supportLink) {
		return null;
	}

	return (
		<a
			className="btn btn--link btn--has-icon btn--support"
			href={KNOWLEDGE_BASE_LINK}
			title={`Need help? - FAQ on ${supportLink}`}
			target="_blank"
			rel="noreferrer"
		>
			<span>Support</span>
		</a>
	);
}
